import { NoSsr } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import clsx from 'clsx';
import React from 'react';
import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary';
import AppHeader from './components/AppHeader';
import MainLayoutCustomerNotification from './components/MainLayoutCustomerNotification';
import MainNavigation from './components/MainNavigation';

export interface MainLayoutProps extends StandardDivProps<MainLayoutClassKey> {
  aside?: React.ReactElement;
  children?: React.ReactNode;
  className?: string;
}

export type MainLayoutClassKey = 'root' | 'content';

const useStyles = makeStyles(
  (theme) =>
    createStyles<MainLayoutClassKey, {}>({
      root: {
        display: 'flex',
      },
      content: {
        marginTop: theme.spacing(8),
        marginBottom: theme.spacing(8),
        flexGrow: 1,
        padding: theme.spacing(3),
        [theme.breakpoints.down('sm')]: {
          padding: theme.spacing(1),
        },
      },
    }),
  { name: 'MainLayout' },
);

const MainLayout: React.FC<MainLayoutProps> = ({ children = null, classes: pClasses, className, aside, ...rest }) => {
  const classes = useStyles({ classes: pClasses });
  const [open, setOpen] = React.useState(false);

  const handleDrawerToggle = React.useCallback((v) => {
    setOpen(typeof v === 'boolean' ? v : (prev) => !prev);
  }, []);

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <AppHeader handleDrawerToggle={handleDrawerToggle} />
      <MainNavigation onClose={() => handleDrawerToggle(false)} open={open} />

      <main className={classes.content}>{children}</main>
      {aside}
      <NoSsr>
        <ErrorBoundary>
          <MainLayoutCustomerNotification />
        </ErrorBoundary>
      </NoSsr>
    </div>
  );
};

MainLayout.displayName = 'MainLayout';

export default MainLayout;
